import axios from "axios";
import { GRAPHQL_API } from "./graphql/endpoint";
import { isTokenExpired, getAccessToken } from "../utils/customStorage";
import { refreshAccessToken as sharedRefresh } from "./auth/refresh";

const graphqlClient = axios.create({
  baseURL: GRAPHQL_API,
  method: 'post'
});

const refreshAccessToken = sharedRefresh;

graphqlClient.interceptors.request.use(async function (config) {
    let token = await getAccessToken();
    if (!token || isTokenExpired(token)) {
      token = await refreshAccessToken();
    }
    if (token) {
      config.headers = { 
        ...config.headers,
        'Authorization': `JWT ${token}` };
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

graphqlClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const newToken = await refreshAccessToken();
      if (newToken) {
        originalRequest.headers = {
          ...originalRequest.headers,
          Authorization: `JWT ${newToken}`,
        };
        return graphqlClient(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default graphqlClient;